module.exports = __webpack_public_path__ + "static/media/smart-card@2x.b1da7453.png";